module.exports = __webpack_public_path__ + "static/media/TEST_IMAGE_VERTICAL.9a51f250.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/TEST_IMAGE_VERTICAL.png
// module id = 326
// module chunks = 0